export default {
  weddingManager: null,
  weddingsLength: 0,
  weddingOf: {},
  weddingExists: {}
}
